export { AI_ASSISTANT_AVATAR, AI_SENDER_NAME } from '@/app/common/constants/ai';

export const DEFAULT_MODAL_SIZE = { width: 750, height: 700 };
